/* eslint-disable @typescript-eslint/naming-convention */
import { gsap } from "gsap/gsap-core";
import { CSSPlugin } from "gsap";
import { CustomEase } from "gsap/CustomEase";

// CustomEase outside this file can make problems - CustomEase IDs dont work
gsap.registerPlugin(CSSPlugin, CustomEase);

export const enum CustomEaseDurations {
    MOTION_DURATION_0 = 0,
    MOTION_DURATION_100 = 0.1,
    MOTION_DURATION_250 = 0.25,
    MOTION_DURATION_500 = 0.5,
    MOTION_DURATION_1000 = 1,
}

export const enum CustomEaseNames {
    MOTION_LINEAR = "motion-linear",
    MOTION_EASE_IN_OUT = "motion-ease-in-out",
    MOTION_EASE_OUT = "motion-ease-out",
    MOTION_EASE_IN = "motion-ease-in",
}

CustomEase.create(CustomEaseNames.MOTION_LINEAR, "M0,0 C0.42,0 0.58,1 1,1");
CustomEase.create(CustomEaseNames.MOTION_EASE_IN_OUT, "M0,0 C0.42,0 0.58,1 1,1");
CustomEase.create(CustomEaseNames.MOTION_EASE_OUT, "M0,0 C0.19,0.91 0.38,1 1,1");
CustomEase.create(CustomEaseNames.MOTION_EASE_IN, "M0,0 C0.42,0 1,1 1,1");

/**
 * GSAP instance with custom extensions (for etc. DS Custom eases).
 * @param args GSAP Plugins
 * @returns gsap instance
 */
export function useGsap(...args: object[]) {
    gsap.registerPlugin(...args);

    return { gsap };
}
